import { DropdownOptions } from '@components/common/formControl/dropdown';
import { formatTime, roundToNearestQuarterHour } from '@helper/utils';
import { Member } from '@services/hooks/meetings';

export interface IDefaultAddMeetingFormInitialValues {
	meetingType: string;
	mdi: string;
	name: string;
	contact: number | string;
	town: string;
	startdate: string;
	enddate: string;
	start_time_c: string;
	meetingTheme: string;
	end_time_c: string;
	club: DropdownOptions[];
	fccClub: string;
	meetingVenue: string;
	primaryFocusProduct: string;
	secondaryFocusProduct: string;
	product1Discussed: string;
	product2Discussed: string;
	meetFormat: string;
	participants: Member[];
	status: string;
	imr_code: DropdownOptions[];
	role?: string;
	dealer?: string;
	meetingLatitude?: string;
	meetingLongitude?: string;
	obMeetSelection?: string;
	electionNominationEndDate?: string;
	electionNominationEndTime?: string;
	cmdi?: string;
	RBDMclub?: string;
	rbdm_code?: string;
	rbdmTown?: string;
	meetingSfid?: string;
	meetSubCategory?: string;
	primaryFocusProductLcdMeets?: DropdownOptions[];
}

export interface IRBDMAddMeetingFormInitialValues {
	meetingType: string;
	name: string;
	startdate: string;
	enddate: string;
	start_time_c: string;
	end_time_c: string;
	meetingTheme: string;
	meetingVenue: string;
	cmdi: string;
	RBDMclub: string;
	rbdmTown?: string;
	meetingSfid?: string;
	dealer?: string;
	meetSubCategory?: string;
	primaryFocusProductLcdMeets?: DropdownOptions[];
}

const now = new Date();

export const fccProductAwarnessStartDate = ((): Date => {
	const d = roundToNearestQuarterHour(now);
	d.setDate(d.getDate() + 5);
	return d;
})();

const startDate = roundToNearestQuarterHour(now);
const endDate = new Date(startDate.getTime() + 60 * 60 * 1000);

export const defaultAddMeetingInitialValues: IDefaultAddMeetingFormInitialValues = {
	meetingType: '',
	mdi: '',
	name: '',
	contact: '',
	town: '',
	startdate: new Date().toISOString(),
	enddate: endDate.toISOString(),
	start_time_c: formatTime(startDate),
	end_time_c: formatTime(endDate),
	club: [],
	fccClub: '',
	meetingVenue: '',
	primaryFocusProduct: '',
	secondaryFocusProduct: '',
	product1Discussed: '',
	product2Discussed: '',
	meetFormat: 'Physical',
	participants: [],
	meetingTheme: '',
	status: '',
	imr_code: [],
	role: '',
	dealer: '',
	meetingLatitude: '',
	meetingLongitude: '',
	electionNominationEndDate: '',
	electionNominationEndTime: '',
	cmdi: '',
	RBDMclub: '',
	rbdm_code: '',
	primaryFocusProductLcdMeets: [],
};

export const defaultRBDMAddMeetingInitialValues: IRBDMAddMeetingFormInitialValues = {
	meetingType: '',
	name: '',
	startdate: new Date().toISOString(),
	enddate: endDate.toISOString(),
	start_time_c: formatTime(startDate),
	end_time_c: formatTime(endDate),
	meetingTheme: '',
	meetingVenue: '',
	cmdi: '',
	RBDMclub: '',
	rbdmTown: '',
};

export const TSIMeetingTypes = [
	{ id: 1, value: 'One to Many Meeting' },
	{ id: 2, value: 'One to One Meeting' },
];

export const IsLcdWiseUserMeet = 'LCD wise User Meet';
export const SocialMeetSubTypes = [
	{ id: 1, value: 'Yoga Diwas' },
	{ id: 2, value: 'Vriksharopan Diwas' },
	{ id: 3, value: 'Shramdan Diwas' },
	{ id: 4, value: 'Blood Donation' },
	{ id: 5, value: 'Run for Fun' },
	{ id: 6, value: 'Career Counselling' },
	{ id: 7, value: 'Medical Camp' },
	{ id: 8, value: 'Local Sports Events' },
	{ id: 9, value: 'Kite Festival - Sankranti' },
	{ id: 10, value: 'Activities' },
	{ id: 11, value: 'Vishwakarma Pooja' },
	{ id: 12, value: 'Vishwakarma Jayanti' },
	{ id: 13, value: 'Holi Milan' },
	{ id: 14, value: 'Roza / Iftar' },
	{ id: 15, value: 'Onam' },
	{ id: 16, value: 'Chat Pooja' },
	{ id: 17, value: 'Karwa Chauth' },
	{ id: 18, value: 'Pongal / Ugadi' },
	{ id: 19, value: 'Diwali' },
	{ id: 20, value: 'Ganesh Chaturthi' },
	{ id: 21, value: 'F&B Distribution' },
];

export const SocialMeetType = 'OTHER SOCIAL ACTIVITIES';

export const MaxLimitMap: Record<string, number> = {
	'FCC PRODUCT AWARENESS MEET': 2,
};

export const LCD_MEETS_SHOP_HALL = 'LCD wise User Meet';

export const PRODUCT_PROMOTION_MEET = 'product specific user events';

export const OFFICE_BEARER_MEET = 'OFFICE BEARER MEET';

export const RETRIVE_OFFICE_BEARER_MEET = 'Office Bearer Meet';

export const SMALL_GROUP_ACTIVITY = 'small group activity (sga) / sga at sites for training / in shop meet';

export const CARNIVAL_REDEMPTION_MEET = 'Club MELA (FCC/DFCC/SCC and others)';

export const CITY_LEAVEL_OB_MEET = 'City Level OB Meets';

export const MEETING_THEME_HIDE_MEETING_TYPE = [
	LCD_MEETS_SHOP_HALL,
	SocialMeetType,
	PRODUCT_PROMOTION_MEET,
	CITY_LEAVEL_OB_MEET,
	OFFICE_BEARER_MEET,
	SMALL_GROUP_ACTIVITY,
	RETRIVE_OFFICE_BEARER_MEET,
];

export const MEETING_HIDE_FOCUS_PRODUCT = [
	LCD_MEETS_SHOP_HALL,
	SocialMeetType,
	CARNIVAL_REDEMPTION_MEET,
	OFFICE_BEARER_MEET,
	RETRIVE_OFFICE_BEARER_MEET,
];

export const MEETING_HIDE_CLUB = [PRODUCT_PROMOTION_MEET, SMALL_GROUP_ACTIVITY];

export const START_DATE_RESTRICTION_MEET = 'FCC PRODUCT AWARENESS MEET';

export const MEETING_PARTICIPANTS_REMOVE = ['Samaj Influencer Lunch'];

/** BDE codes allowed to select more than one club on an Office Bearer Meet. */
export const OFFICE_BEARER_MULTI_CLUB_BDE_CODES: string[] = [
	'BDABD05',
	'BDACL01',
	'BDAPT01',
	'BDBBN02',
	'BDBBN03',
	'BDBBN04',
	'BDCHE01',
	'BDCHE03',
	'BDCMB02',
	'BDCMB04',
	'BDDEL04',
	'BDEALI1',
	'BDECHN6',
	'BDEKER1',
	'BDEKER5',
	'BDEUP02',
	'BDGZB01',
	'BDHUB04',
	'BDHYD05',
	'BDIND01',
	'BDIND04',
	'BDJAI04',
	'BDKAN03',
	'BDKOL01',
	'BDKOL04',
	'BDKOL05',
	'BDLDH03',
	'BDMUM03',
	'BDMUM04',
	'BDSRT01',
	'BDSRT02',
	'FCCCHN1',
	'FCCCHN3',
	'FCCKAN1',
	'FCCKOL1',
];

export const isOfficeBearerMeetType = (meetingType?: string | null): boolean =>
	meetingType?.trim().toLowerCase() === OFFICE_BEARER_MEET.toLowerCase();

export const canSelectMultipleOfficeBearerClubs = (bdeCode?: string | null): boolean =>
	OFFICE_BEARER_MULTI_CLUB_BDE_CODES.includes(bdeCode?.trim() ?? '');
